import { Action } from 'redux';
import { put, takeEvery, call, select } from 'redux-saga/effects';
import { fetchJson } from '../util/fetchUtils';
import { FETCH_START, FETCH_END, FETCH_ERROR } from 'actions/aor/types';
import { RootState } from '../reducers/rootReducer';
import { API_URL } from '../config';
import { fromNullable } from 'fp-ts/lib/Option';
import { LOAD_VALUE_SET_GROUP, VALUE_SET_GROUP_NOT_RECEIVED, VALUE_SET_GROUP_RECEIVED } from '../actions/constants';
import buildFetchOptions from './util/buildFetchOptions';

type ActionType = {
    payload: {
        valueSetCode: string;
        group: string;
    };
} & Action;
export function* loadValueSetGroup(action: ActionType) {
    const { valueSetCode, group } = action.payload;
    const fetchValueSetGroup = yield select((state: RootState): boolean =>
        fromNullable(state.valueSets)
            .chain(valueSets => fromNullable(valueSets[valueSetCode]))
            .fold(
                true, // if the valueset isn't found, lets fetch
                (
                    valueSet, // if it is, and invalid is false, fetch depending on if group is not found or invalid
                ) => valueSet.invalid || fromNullable(valueSet.groups[group]).fold(true, vsgroup => vsgroup.invalid),
            ),
    );
    if (!fetchValueSetGroup) {
        // don't fetch
        console.log(`cache is valid so don't load group ${group} for valueSet ${valueSetCode}`); //tslint:disable-line
        return;
    } else {
        console.log(`cache is invalid: loading group ${group} for valueSet ${valueSetCode}`); //tslint:disable-line
    }
    yield put({ type: FETCH_START });
    try {
        const options = buildFetchOptions();
        const { status, body } = yield call(fetchJson, `${API_URL}value-set/${valueSetCode}/${group}`, options);
        if (status === 200) {
            const response = JSON.parse(body);
            yield put({
                type: VALUE_SET_GROUP_RECEIVED,
                payload: {
                    response,
                    data: {
                        entities: {
                            Concept: Object.assign(
                                {},
                                ...response.concepts.map(c => ({
                                    [c.id]: {
                                        // we are loosing some data here, at least keep the most important.
                                        entityType: 'Concept',
                                        valueSet: response.id,
                                        valueSetId: response.id,
                                        ...c,
                                    },
                                })),
                            ),
                        },
                        result: response.concepts.map(c => c.id),
                    },
                },
                requestPayload: action.payload,
            });
            yield put({ type: FETCH_END });
        } else {
            yield put({ type: VALUE_SET_GROUP_NOT_RECEIVED, status });
            yield put({ type: FETCH_ERROR });
        }
    } catch (error) {
        yield put({ type: VALUE_SET_GROUP_NOT_RECEIVED, error });
        yield put({ type: FETCH_ERROR, error });
    }
}

export default function* getViewConfigOnLoginSaga() {
    yield takeEvery(LOAD_VALUE_SET_GROUP, function*(action: ActionType) {
        yield call(loadValueSetGroup, action);
    });
}
